<app-file-upload
  #fileUpload
  class="hidden-file-upload"
  [acceptedFileTypes]="['pdf', 'docx']"
  [maxSize]="maxAgendaSize"
  type="agenda"
  (fileChange)="onFileChange($event)"
  (progressChange)="uploadStarted.emit()"
  (uploadFailed)="onUploadFailed($event)"
></app-file-upload>

<div class="source-options">
  <!-- Upload Agenda Option -->
  <div
    class="source-option upload-option"
    [class.disabled]="!canEdit || isUploadInProgress"
    [class.dragging]="isDragging"
    [class.importing]="isUploadInProgress || status === 'checking'"
    [class.uploaded]="status === 'uploaded' && !isUploadInProgress && templateSourceType === 'UPLOAD'"
    [class.failed]="status === 'failed'"
    [class.selected]="templateSourceType === 'UPLOAD'"
    (click)="canStartUpload && !requiresConfirmation && onUploadCardClick()"
    (dragover)="canStartUpload && !requiresConfirmation && onDragOver($event)"
    (dragleave)="canStartUpload && !requiresConfirmation && onDragLeave()"
    (drop)="canStartUpload && !requiresConfirmation && onDrop($event)"
  >
    @if (requiresConfirmation && canStartUpload) {
      <div class="confirmation-overlay" (click)="confirmationRequested.emit(); $event.stopPropagation()"></div>
    }
    @if (isUploadInProgress) {
      <div class="option-icon importing">
        <mat-icon>hourglass_empty</mat-icon>
      </div>
      <span class="option-title">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.IMPORTING_AGENDA' | translate }}</span>
      <app-progress-loader indeterminate class="importing-progress"></app-progress-loader>
    } @else if (status === 'failed') {
      <div class="option-icon failed">
        <mat-icon>error_outline</mat-icon>
      </div>
      <span class="option-title failed">
        {{ failureMessageKey | translate }}
      </span>
      @if (uploadedFileName !== null) {
        <span class="option-filename" [matTooltip]="uploadedFileName">
          <mat-icon class="file-icon">description</mat-icon>
          <span class="filename-text">{{ displayFileName }}</span>
        </span>
      }
      @if (canEdit) {
        <span class="option-replace-link">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.REPLACE_AGENDA' | translate }}</span>
      }
    } @else if (status === 'checking') {
      <div class="option-icon importing">
        <mat-icon>hourglass_empty</mat-icon>
      </div>
      <span class="option-title">{{ 'MEETING_SETUP.TEMPLATE_REVIEW.CHECKING_AGENDA_DOCUMENT' | translate }}</span>
      <app-progress-loader indeterminate class="importing-progress"></app-progress-loader>
    } @else if (status === 'uploaded' && templateSourceType === 'UPLOAD') {
      <div class="option-icon uploaded">
        <mat-icon>check</mat-icon>
      </div>
      <span class="option-title uploaded">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.AGENDA_UPLOADED' | translate }}</span>
      @if (uploadedFileName !== null) {
        <span class="option-filename" [matTooltip]="uploadedFileName">
          <mat-icon class="file-icon">description</mat-icon>
          <span class="filename-text">{{ displayFileName }}</span>
        </span>
      }
      @if (canEdit) {
        <span class="option-replace-link">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.REPLACE_AGENDA' | translate }}</span>
      }
    } @else {
      <div class="option-icon">
        <mat-icon>upload</mat-icon>
      </div>
      <span class="option-title">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.UPLOAD_AGENDA' | translate }}</span>
      <span class="option-description">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.UPLOAD_AGENDA_DESC' | translate }}</span>
      <span class="option-formats">PDF, DOCX</span>
    }
  </div>

  <!-- Create New Option -->
  <div
    class="source-option"
    [class.disabled]="!canEdit || isUploadInProgress"
    [class.selected]="templateSourceType === 'CREATE'"
    (click)="canEdit && !isUploadInProgress && createNewClicked.emit()"
  >
    <div class="option-icon">
      <mat-icon>add</mat-icon>
    </div>
    <span class="option-title">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.CREATE_NEW' | translate }}</span>
    <span class="option-description">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.CREATE_NEW_DESC' | translate }}</span>
  </div>

  <!-- Load Saved Option -->
  <div
    class="source-option"
    [class.disabled]="!canEdit || isUploadInProgress"
    [class.selected]="templateSourceType === 'LOAD'"
    (click)="canEdit && !isUploadInProgress && loadSavedClicked.emit()"
  >
    <div class="option-icon">
      <mat-icon>folder_open</mat-icon>
    </div>
    <span class="option-title">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.LOAD_SAVED' | translate }}</span>
    <span class="option-description">{{ 'MEETING_SETUP.TEMPLATE_SOURCE.LOAD_SAVED_DESC' | translate }}</span>
  </div>
</div>
